import React, { Component } from 'react';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import Iframe from 'react-iframe';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';

import Popup from '../Popup';
import { commonStyles, COLORS } from '../../styles/styles';
import { SERVER_LINK, STATUSES, STORAGE_LINK } from '../../constants';
import { statusCode } from '../../utils';
import IframeComm from 'react-iframe-comm';
import {
  selectAssessment
} from '../../redux/reducers/userProgramsFull';
import {
  saveTimeTaken,
  addComponentStatusRequest,
  saveStatus,
} from '../../redux/reducers/addComponentStatus';

import {
  assignmentRequestRequest
} from '../../redux/reducers/assignmentRequest';

import PDFTron from '../PDFTron';

import {
  saveAnnotationRequest,
  selectAnnotationSave
} from '../../redux/reducers/annotations';

import { selectedModule, selectedContentItem, selectedModuleId, selectedProgramId, selectedContent } from '../../redux/selectors';


class IframePopup extends Component {
 
constructor(props){
  super(props)
  this.frameDiv = React.createRef()
}
render(){
  const {
    classes,
    handlePopupToggle,
    pathToIframeFile,
    selectedContentItem,
    handleMessage,
    handlePauseVideo,
    saveStatus,
    handleUpdateStatus,
    handleAssignmentStatus,
    handleSaveAnnotations,
    handlePDFTRONSENDMessage,
    saveContent,
    user,
    submitMCQ,
    viewAssignment,
    selectedAttempt,
    getHTMLPath,
    handlePDFTRONMessage,
    logbookImage
   
  } = this.props;

  const postMessageData = {msg:'LOGBOOKIMAGE',img:logbookImage};

  
  
  return (
    <Popup>

      <div className="popupHolder">
        <div className="iframePopup">

        <div className={classes.popupHeader}>
            <Clear
              className={classes.closePopup}
              onClick={() => {
                
                if (selectedContentItem) {
                  if(selectedContentItem.type=='Document'){
                    
                    handlePDFTRONSENDMessage(selectedContentItem, this)
                  }else if (Object.keys(selectedContentItem).length > 1) {
                    
                    handlePopupToggle(selectedContentItem);
                  } else {
                    
                    handlePopupToggle(false);
                  }
                }
              }}
            />
          </div>
          
          <div className={classes.iframeContainer}>
        
          {(selectedContentItem.type === 'Assignments' && submitMCQ) && (
             (<IframeComm attributes={ {src: SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&mid='+selectedContentItem.module_id+'&rid='+selectedContentItem.rid+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=1'+'&logbook=0',
             width: "100%",
             height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}

  {(selectedContentItem.type === 'WSR Assessments' && submitMCQ) && (
             (<IframeComm  postMessageData={postMessageData} attributes={ {src: SERVER_LINK+'/survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&mid='+selectedContentItem.module_id+'&rid='+selectedContentItem.rid+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=1'+'&logbook=1',
             width: "100%",
             height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}

  {(selectedContentItem.type === 'Survey') && (
             (<IframeComm attributes={ {src: SERVER_LINK+'survey/surveyview_generator.html?pid=web&sid='+selectedContentItem.survey_id+'&mid='+selectedContentItem.module_id+'&rid='+selectedContentItem.rid+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&logbook=0',
             width: "100%",
             height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}

  {(selectedContentItem.type === 'HTML Captivate' || selectedContentItem.type === 'HTML Articlulate') && (
             (<IframeComm attributes={ {src: getHTMLPath(selectedContentItem.path),
              width: "100%",
              height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}
             {(selectedContentItem.type === 'Assignments' && !submitMCQ && !viewAssignment) && (
             (<IframeComm attributes={ {src: SERVER_LINK+'survey/surveyview_js.html?pid=web&sid='+selectedContentItem.survey_id+'&mid='+selectedContentItem.module_id+'&rid='+selectedContentItem.rid+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0'+'&logbook=0',
              width: "100%",
              height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}
             {(selectedContentItem.type === 'Assignments' && !submitMCQ && viewAssignment) && (
             (<IframeComm attributes={ {src: SERVER_LINK+'survey/surveyview_js.html?pid=web&sid='+selectedContentItem.survey_id+'&mid='+selectedContentItem.module_id+'&rid='+selectedContentItem.rid+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0&editable=0&attempt='+selectedAttempt+'&logbook=0',
              width: "100%",
              height: "100%",
          }}
          
       />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}
            {(selectedContentItem.type === 'WSR Assessments' && !submitMCQ && !viewAssignment) && (
             (<IframeComm  attributes={ {src: SERVER_LINK+'/survey/surveyview_js.html?pid=web&sid='+selectedContentItem.survey_id+'&mid='+selectedContentItem.module_id+'&rid='+selectedContentItem.rid+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0'+'&logbook=0',
              width: "100%",
              height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}
             {(selectedContentItem.type === 'WSR Assessments' && !submitMCQ && viewAssignment) && (
             (<IframeComm attributes={ {src: STORAGE_LINK+'/survey/surveyview_js.html?pid=web&sid='+selectedContentItem.survey_id+'&mid='+selectedContentItem.module_id+'&rid='+selectedContentItem.rid+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0&editable=0&attempt='+selectedAttempt+'&logbook=0',
              width: "100%",
              height: "100%",
          }}
          
       />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={STORAGE_LINK+'survey/surveyview_js.html?sid='+selectedContentItem.survey_id+'&uid='+user.user.userId+'&loc='+selectedContentItem.path+'&calculate=0' }/>
            )}
            {selectedContentItem.type === 'Document' && (
                <IframeComm  ref={(ref) => { this.frameDiv = ref }} attributes={ {src: STORAGE_LINK+'viewer/?url='+selectedContentItem.path+'&pdf_json='+selectedContentItem.pdf_json,
                width: "100%",
                height: "100%",
             }}
             
          handleReceiveMessage={handlePDFTRONMessage} />
            )}
            {}
            {(selectedContentItem.type === 'Image' ||
              selectedContentItem.type === 'png' ||
              selectedContentItem.type === 'jpg') && (
              <img className={classes.image} src={pathToIframeFile} alt={pathToIframeFile} />
            )}
            {selectedContentItem.type === 'Video' && (
              <ReactPlayer
                className={classes.videoPopup}
                url={pathToIframeFile}
                onPause={handlePauseVideo}
                onProgress={e => handleUpdateStatus(e)}
                onEnded={() => {
                  saveStatus(STATUSES.completed.value);
                  handlePopupToggle(selectedContentItem);
                }}
                controls
                playing
              />
            )}
          </div>
        </div>
      </div>
    </Popup>
  );
}
};

const styles = () => ({
  ...commonStyles,
  image: {
    margin: '0 auto',
    display: 'block',
    maxWidth: 1200,
    width: '98%',
  },
  iframeContainer: {
    position: 'absolute',
    overflow: 'scroll',
    top:34,
    bottom:0,
    left:0,
    right:0
  },
  videoPopup: {
    width: '100%!important',
    height: '100%!important',
  },

  popupIframe: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 10,
  },
  popupHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor:COLORS.yellow,
    color: '#ffffff'
  },
  closePopup: {
    color: '#fff',
    background: 'transparent',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    margin: '10px 5px 0 0',
  },
});
const mapDispatchToProps = dispatch => ({
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  assignmentRequestRequest: type => dispatch(assignmentRequestRequest(type)),
  selectAnnotationSave: json => dispatch(selectAnnotationSave(json)),
  saveAnnotationRequest: () => dispatch(saveAnnotationRequest()),
});

const mapStateToProps = state => ({
  user: state.loginReducer,
  submitMCQ: state.userProgramsFullReducer.submitMCQ,
  selectedAttempt: state.userProgramsFullReducer.selectedAttempt,
  viewAssignment: state.userProgramsFullReducer.viewAssignment,
  selectedContentItem: selectedContent(state),
  logbookImage: state.userProgramsFullReducer.logbookImage
});
export default compose(
  withState('statusComponent', 'handleChangeStatus', 0),
  withState('startTimePdf', 'handleSpentTimePdf', 0),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentDidMount() {
      const {
        contentIframe,
        saveTimeTaken,
        saveStatus,
        selectedContentItem,
        addComponentStatusRequest,
        handleSpentTimePdf,
      } = this.props;
      if (contentIframe) {
        saveTimeTaken(0);
        
        // if(selectedContentItem.type != 'Assignments'){
        //   saveStatus(statusCode(selectedContentItem.status));
         
          
        //   addComponentStatusRequest();
  
        //   handleSpentTimePdf(Date.now());
        // }
        
      }
    },
    componentWillReceiveProps(nextProps) {
      const { addComponentStatus: thisAddComponentStatus, contentIframe } = this.props;
      const { addComponentStatus: nextAddComponentStatus, handleChangeStatus, status } = nextProps;

      // if (contentIframe) {
      //   if (nextAddComponentStatus.status !== thisAddComponentStatus.status) {
      //     handleChangeStatus(status);
      //   }
      // }
    },
    componentWillUnmount() {
      const {
        selectedContentItem: { type: contentType },
        contentIframe,
        saveStatus,
        saveTimeTaken,
        addComponentStatusRequest,
        startTimePdf,
      } = this.props;
      if (
        saveStatus &&
        (contentType === 'Image' ||
          contentType === 'jpg' ||
          contentType === 'png' ||
          contentType === 'Document' ||
          contentType === 'HTML Captivate' ||
          contentType === 'HTML Articlulate')
      ) {
        saveStatus(STATUSES.completed.value);
      }
      if (contentIframe && contentType!='Assignments' && contentType!='Survey') {
        
        saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
        addComponentStatusRequest();
      }
    },
  }),
  withHandlers({
    handleUpdateStatus: props => e => {
      const { selectedContentItem, saveStatus, saveTimeTaken } = props;
      
      if (selectedContentItem.status !== STATUSES.completed.value) {
        saveStatus(STATUSES.inProgress.value);
      }
      saveTimeTaken(Math.round(e.playedSeconds / 1000));
    },
    getHTMLPath: props => path => {
      var p = path.split('.zip')
      return p[0]+'/index.html'
    },
    handlePDFTRONMessage: props => e => {
    
      var obj = JSON.parse(e.data)
      
      
      props.selectAnnotationSave(obj.annotations)
      props.saveAnnotationRequest()
      props.handlePopupToggle(props.selectedContentItem);
    },
    handlePDFTRONSENDMessage: props => (e, p) => {
      
     p.frameDiv.sendMessage('save', "*")
    },
    handleMessage: props => e => {
      const { addComponentStatusRequest, saveStatus, saveTimeTaken, handleAssignmentStatus, selectedContentItem, submitMCQ, assignmentRequestRequest, selectAssessent } = props;
      
    try {
      var msg = JSON.parse(e.data);
    
      if(msg.action==='STATUS'){
       
        if(msg.status==='ready' && selectedContentItem.status !== 'ready'){
         
          handleAssignmentStatus(msg.status);
        }else if(msg.status==='completed' && selectedContentItem.status !== 'completed'){
          if(msg.result.passed=='NYC'){
            if(selectedContentItem.attempts.length==0){
              if(submitMCQ==true){
                
                selectAssessment(selectedContentItem.survey_id);
                // selectUserAssessment(content.survey_id);
                assignmentRequestRequest('retake');
               
                 saveStatus(STATUSES.resubmission_request.value);
                // addComponentStatusRequest();
              }
            
            }else{
             
              handleAssignmentStatus('submitted');
            }
          
          }else{
            handleAssignmentStatus('completed');
          }
         
         
        }else if(msg.status==='in progress' && (selectedContentItem.status !== 'in progress' || selectedContentItem.status !== 'ready')){
          
          handleAssignmentStatus(msg.status);
          
        }else if(msg.status==='marking' && (selectedContentItem.status !== 'marking')){
          
          handleAssignmentStatus(msg.status);
          
        }else if(msg.status==='completed' && (selectedContentItem.status !== 'marking')){
          
          handleAssignmentStatus(msg.status);
          
        }
        
        
      }else if(msg.status==='completed' && (selectedContentItem.status !== 'marking')){
        
        handleAssignmentStatus(msg.status);
        
      }else if(msg.status==='in progress' && (selectedContentItem.status !== 'in progress' || selectedContentItem.status !== 'ready')){
        
        handleAssignmentStatus(msg.status);
        
      }else if(selectedContentItem.type === 'HTML Captivate' || selectedContentItem.type === 'HTML Articlulate'){
        
        saveStatus(STATUSES.completed.value);
        
      }
    } catch (error) {
      
    }
     
    },
  }),
  withStyles(styles),
)(IframePopup);

IframePopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectedContentItem: PropTypes.instanceOf(Object),
  handlePopupToggle: PropTypes.func,
  handlePauseVideo: PropTypes.func,
  handleUpdateStatus: PropTypes.func,
  saveStatus: PropTypes.func,
  pathToIframeFile: PropTypes.string,
};
